let triggerClass = ".Filters-sort-submenu-trigger";
let activeClassName = "is-open";
let containerElement = document.querySelectorAll(".Filters-sort-item");
let sortBySelect = document.getElementById("SortBy");

const gatherElements = () => {
    triggerClass = ".Filters-sort-submenu-trigger";
    activeClassName = "is-open";
    containerElement = document.querySelectorAll(".Filters-sort-item");
    sortBySelect = document.getElementById("SortBy");
};
const toggleOpen = () => {
    containerElement.forEach(item => {
        item.classList.toggle(activeClassName);
    });
};

const selectSort = value => {
    sortBySelect.value = value;
    const event = new Event("input");
    sortBySelect.closest("form").dispatchEvent(event);
};

const isVisible = () => containerElement[0].classList.contains(activeClassName);

// https://stackoverflow.com/questions/152975/how-do-i-detect-a-click-outside-an-element
function hideOnClickOutside() {
    const removeClickListener = () => {
        document.removeEventListener("click", outsideClickListener);
    };

    const outsideClickListener = event => {
        containerElement.forEach(item => {
            if (!item.contains(event.target) && isVisible()) {
                item.classList.remove(activeClassName);
                removeClickListener();
            }
        });
    };

    document.addEventListener("click", outsideClickListener);
}

function init() {
    gatherElements();
    document.querySelectorAll(triggerClass).forEach(item => {
        item.addEventListener("click", e => {
            e.target.ariaExpanded = e.target.ariaExpanded !== "true" ? "true" : "false";
            toggleOpen();
            hideOnClickOutside();
        });
    });

    document
        .querySelectorAll(".Filter-sort-submenu-item .Filter-sort")
        .forEach(item => {
            item.addEventListener("click", e => {
                selectSort(e.target.dataset.optionValue);
            });
        });
}

init();

document.addEventListener("facet-pages-rendered", () => {
    init();
});
